import React, { useState, useEffect, useMemo } from 'react';
import { getPastDueCount } from 'src/modules/onePlace/activitiesAndTasks/activities/services/myActivitiesService';
import PropTypes from 'prop-types';
import OverdueCountContext from './OverdueCountContext';
import getLogger from '../utils/logger';

const OverdueCountContextProvider = (props) => {
  const { isControlPanelMyLearningEnabled = defaultProps.isControlPanelMyLearningEnabled } = props;
  const [overdueCountContext, setOverdueCountContext] = useState(0);
  const logger = getLogger();

  // Use useMemo to memoize the value object
  const value = useMemo(() => {
    return { overdueCountContext, setOverdueCountContext };
  }, [overdueCountContext]); // Only recreate when overdueCountContext changes

  useEffect(() => {
    fetchPastDueCount();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isControlPanelMyLearningEnabled]);

  const fetchPastDueCount = async () => {
    try {
      if (isControlPanelMyLearningEnabled) {
        const { data } = await getPastDueCount({});
        const count = data?.[0]?.pastDueTrainingCount || 0;
        setOverdueCountContext(count);
      }
    } catch (error) {
      logger.error(error);
      setOverdueCountContext(0);
    }
  };

  return <OverdueCountContext.Provider value={value} {...props} />;
};
OverdueCountContextProvider.propTypes = {
  /**
   Is my learning enabled
  * */
  isControlPanelMyLearningEnabled: PropTypes.bool
};

const defaultProps = {
  isControlPanelMyLearningEnabled: false
};
export default OverdueCountContextProvider;
